import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";

interface PaymentCardProps {
  inputsObject?: {
    label: string;
    value: string | number;
  }[];
  finalValue?: {
    label: string;
    value: string | number;
  };
}

const PaymentCard: React.FC<PaymentCardProps> = ({
  inputsObject,
  finalValue,
}) => {
  const [isMobile, setIsMobile] = useState(false);  // Always show all items, no expand/collapse

  // Check if screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1029);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
    const visibleItems = inputsObject || [];

  return (
    <div   className={
        isMobile
          ? styles.rectangular_CardContainer
          : styles.rectangularCardContainer
      }>
      <div className={styles.cardContent}>
        {visibleItems.map((item, index) => (
          <div key={index} className={styles.infoRow}>
            <span className={styles.text}>{item.label}</span>
            <div className={styles.valueWithArrow}>
              <span className={styles.text}>{item.value}</span>
            </div>
          </div>
        ))}
        {finalValue && (
          <div className={styles.infoRowGap}>
            <span className={styles.paymentText}>{finalValue.label}</span>
            <span className={styles.paymentText}>
              {finalValue.value}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentCard;